import {useEffect} from 'react';

import {Tracker} from '@udemy/event-tracking';

import {ExternalPageViewEvent} from 'src/events/custom-external-events';

import {RequestDemoWrapper} from '../../components/request-demo/request-demo-wrapper.react-component';

export const DemoFormBody = () => {
    const generateExternalPageViewEvent = () => {
        Tracker.publishEvent(new ExternalPageViewEvent());
    };

    useEffect(() => {
        generateExternalPageViewEvent();
    }, []);

    return <RequestDemoWrapper />;
};
